<template>
  <div class="w-full relative">
    <div id="9088755327" class="hoverText1">
      <img
        :src="getImage(pageData['9088755327'])"
        alt="banner"
        class="w-full h-full object-cover filter-b7"
      />
    </div>
    <div class="absolute top-0 flex justify-center items-center w-full h-full">
      <div class="relative lg:w-1/2 md:w-1/2 w-full px-4">
        <h1
          id="6584152444"
          class="font-semibold text-white hoverText1 fsize50 sm-fsize25 text-center lg:mb-2 md:mb-2 mb-2"
        >
          {{ pageData ? pageData["6584152444"] : "FR ACP" }}
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isShowCMS: false,
      pageData: {},
      selectedId: "",
      direction: "rtl",
    };
  },

  watch: {
    isShowCMS(newValue) {
      console.log(newValue);
    },
    pages(value) {
      this.pageData = value["FR ACP"];
    },
  },
  computed: {
    ...mapState("cms", ["pages", "user"]),
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    getImage(image) {
      if (image && image.includes("data:image/")) {
        return image;
      } else {
        if (image) {
          return `${process.env.VUE_APP_STORAGE_URL}${image}`;
        } else {
          return "https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg";
        }
      }
    },
    async removeClass() {
      let classData = document.getElementsByClassName("hoverText1");

      const elementsArray = Array.from(classData);

      elementsArray.forEach((element) => {
        element.classList.remove("hoverText1");
      });
    },
    addClass() {
      let classData2 = document.getElementsByClassName("hoverText1");

      let classData = document.getElementsByClassName("hoverText1");
      console.log(classData, "home");
      for (let i = 0; i < classData.length; i++) {
        classData[i].classList.add("hoverText1");
        if (classData[i]) {
          console.log(classData[i].id, "ids");
          classData[i].addEventListener("click", () => {
            this.selectedId = classData[i].id;
            console.log(this.selectedId, "selected");
            this.isShowCMS = true;
          });
        }
      }
    },
    async closePopup2() {
      console.log("close");
      this.isShowCMS = false;
      let cms = { projectName: process.env.VUE_APP_COMMUNITY_NAME };
      await this.$store.dispatch("cms/getClientCms", cms);
    },
    init() {
      let popVal = localStorage.getItem("pop");
      let val = Boolean(popVal);
      if (!val) {
        localStorage.setItem("pop", false);
      } else {
        localStorage.setItem("pop", true);
        let pop = localStorage.getItem("pop");
        this.AdPopup = Boolean(pop);
      }
    },
    async closeModal() {
      localStorage.setItem("pop", false);
      this.AdPopup = false;
    },
  },
  async mounted() {
    this.init();
    if (this.pages) {
      this.pageData = this.pages["FR ACP"];
    }

    if (this.$route.query.token === "123") {
      console.log("CMS Active");
      await this.addClass();
    } else {
      await this.removeClass();
    }
  },
};
</script>
